import React from "react";
import DisplayMaster from '../DisplayMaster';

export default function Subcarpathian() {
  return (
    <>
      <DisplayMaster voivodeship="Subcarpathian" />
    </>
  );
}